import { Component, ViewChild, AfterViewInit, HostListener, ElementRef } from '@angular/core';

import { CSECoreService } from 'app/cse.coreService';

declare var $: any;

@Component({
	moduleId: module.id,
	selector: 'inicio-app',
	templateUrl: '../../templates/inicio.component.html',
})

export class InicioComponent implements AfterViewInit {
	title = 'inicio';

	add: string;

	constructor(private cseCore: CSECoreService) {
		if (this.cseCore.config.add && this.cseCore.config.add[0]) {
			this.add = this.cseCore.config.add[0][1];
		} else {
			this.add = "";
		}
	}

	ngAfterViewInit() {
		this.renderizar(window.innerHeight);
		if (this.cseCore.config.add) {
			$('#avisoInformativo').modal("show");
		}
	}

	@ViewChild("mainContent") mainContent: ElementRef;

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.renderizar(event.target.innerHeight);
	}

	renderizar(height: number) {
		this.mainContent.nativeElement.style['height'] = (height - 27) + "px";
	}

}



// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/component/inicio.component.ts